import React, { Component } from "react";
import "./semantic/dist/semantic.min.css";
import Home from "./Home";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Home />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx